import { Image } from '@cian/ui-kit';

import * as styles from './Stub.css';

export const Stub = () => {
  return (
    <div className={styles['container']}>
      <Image src={''} borderRadius="4px" height={246} width={272} />
    </div>
  );
};
